/* ============================================================
   CHRONCES — <cr-announcement-bar>
   Rotation des messages. Vanilla, aucune dépendance.
   ============================================================ */

class CrAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-cr-ann-item]'));
    if (this.items.length < 2) return;

    this.index = this.items.findIndex((el) => el.classList.contains('is-active'));
    if (this.index < 0) this.index = 0;

    this.querySelector('[data-cr-ann-prev]')?.addEventListener('click', () => {
      this.go(-1);
      this.restart();
    });
    this.querySelector('[data-cr-ann-next]')?.addEventListener('click', () => {
      this.go(1);
      this.restart();
    });

    this.speed = parseInt(this.dataset.speed || '4500', 10);
    this.autoplay =
      this.dataset.autoplay === 'true' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.autoplay) return;

    this.start();
    // On suspend pendant la lecture (survol / navigation clavier).
    this.addEventListener('mouseenter', this.stop);
    this.addEventListener('mouseleave', this.start);
    this.addEventListener('focusin', this.stop);
    this.addEventListener('focusout', this.start);
    document.addEventListener('visibilitychange', this.onVisibility);
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  onVisibility = () => (document.hidden ? this.stop() : this.start());

  // Inutile de faire tourner sur un onglet caché : les transitions y sont
  // gelées, on reprendrait au mauvais endroit visuellement.
  start = () => {
    if (!this.autoplay || this.timer || document.hidden) return;
    this.timer = setInterval(() => this.go(1), this.speed);
  };

  stop = () => {
    clearInterval(this.timer);
    this.timer = null;
  };

  restart() {
    this.stop();
    this.start();
  }

  go(direction) {
    const total = this.items.length;
    this.index = (this.index + direction + total) % total;
    this.items.forEach((el, i) => {
      const active = i === this.index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }
}

if (!customElements.get('cr-announcement-bar')) {
  customElements.define('cr-announcement-bar', CrAnnouncementBar);
}
